import { paths } from 'routes';
import { XHTTP, XHTTPBlob } from 'services/api/xhttp';

const END_POINTS = {
  ...paths.api.export,
};

const ExportApi = {
  download: (type, filters) => {
    const body = {
      type,
      filters,
    };

    return XHTTPBlob(
      END_POINTS.generate,
      {
        method: 'post',
        body,
      },
      undefined,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );
  },

  getTypes: () => {
    return XHTTP(END_POINTS.types);
  },
};

export { ExportApi };
